import { CircularProgress, SxProps } from '@mui/material';
import ScreenMessage from './ScreenMessage';

const LoadingMessage = ({ sx, message = 'Loading...' }: { sx?: SxProps; message?: string }) => {
	return <ScreenMessage sx={sx} icon={<CircularProgress />} header={message} />;
};

export default LoadingMessage;
